export function clearRefererUrl(): void {
  localStorage.removeItem('_ref');
}
